import { Icon } from '@/app/components/icons';
import { IconChevronLeft } from '@/app/components/icons/ui-actions/icon-chevron-left';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

interface CollapsePanelButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const CollapsePanelButton = ({
  isOpen,
  onClick,
}: CollapsePanelButtonProps) => {
  const title = isOpen ? 'Collapse Side Panel' : 'Expand Side Panel';
  return (
    <button
      title={title}
      className="rounded-r-2xs center-y absolute left-full z-10 hidden h-20 w-6 cursor-pointer bg-white py-2 xl:block"
      aria-label={title}
      onClick={onClick}
      {...createDataAttributes({ test: 'collapse-panel' })}
    >
      <Icon
        icon={<IconChevronLeft />}
        className={cn('ease-bounce transition-transform duration-300', {
          'rotate-180': !isOpen,
        })}
      />
    </button>
  );
};
